/**
 * TanStack Query hooks for `igaming-pricing`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingPricingQueryKeys,
	type CreateIgamingPricingBody,
	type ListIgamingPricingResponse,
	type IgamingPricingRow,
} from "./api";

export function useIgamingPricingList(): UseQueryResult<ListIgamingPricingResponse, Error> {
	return useQuery({
		queryKey: igamingPricingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingPricingCreate(): UseMutationResult<IgamingPricingRow, Error, CreateIgamingPricingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPricingQueryKeys.all });
		},
	});
}

export function useIgamingPricingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPricingQueryKeys.all });
		},
	});
}
